import Signup from "./pages/signup/signup";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { IRoute } from "./@types/route";
import RequireAuth from "./components/requireAuth";
import Login from "./pages/login/login";
import ForgotPassword from "./pages/forgotPassword/forgotPassword";
import NewPassword from "./pages/newPassword/newPassword";
import Home from "./pages/home/home";
import CardManagement from "./pages/cardManagement/cardManagement";
import NewCard from "./pages/newCard/newCard";
import Profile from "./pages/profile/profile";
import Admin from "./pages/admin/admin";
import Supplier from "./pages/supplier/supplier";
import ProcessingManagement from "./pages/processingManagement/processingManagement";
import CardRequest from "./pages/cardRequest/cardRequest";
import TransactionHistory from "./pages/transaction-history/transaction-history";
import NewSupplier from "./pages/new-supplier/new-supplier";
import NewProcessing from "./pages/new-processing/new-processing";
import ProcessingTeam from "./pages/processingTeam/processingTeam";
import UserManagementCard from "./pages/userManagementCard/userManagementCard";
import Unauthorized from "./components/unathorized";
import Header from "./pages/landing/header";
import HomeScreen from "./pages/landing/HomeScreen";
import FraudPrevention from "./pages/landing/fraud";
import TermsOfSale from "./pages/landing/termsOfSale";
import TermsOfUse from "./pages/landing/termsOfUse";
import FinancialDisclosure from "./pages/landing/financialDisclosure";
import AffiliateDisclosure from "./pages/landing/affiliateDisclosure";
import TermsAndConditions from "./pages/landing/termsAndConditions";
import PrivacyPolicy from "./pages/landing/privacyPolicy";
import ScrollToTop from "./components/scrollToTop";
import UserManagement from "./pages/userManagementCard/userManagement";
import AdminRateInfo from "./pages/adminRateInfo/adminRateInfo";
import SupplierRateInfo from "./pages/supplierRateInfo/SupplierRateInfo";
import SupplierPaymentInfo from "./pages/supplierPaymentInfo/supplierPaymentInfo";
import KYC from "./components/KYC";
import VerificataionLimit from "./pages/VerificationLimit/VerificationLimit";
import RefundPolicy from "./pages/landing/refundPolicy";

const routes: IRoute[] = [
  {
    link: "/supplier",
    component: <Home />,
    protectedPath: true,
    children: [
      {
        link: "",
        component: <CardManagement />,
      },
      {
        link: "new-card",
        component: <NewCard />,
      },
      {
        link: "rate-info",
        component: <SupplierRateInfo />,
      },
      {
        link: "payment-info",
        component: <SupplierPaymentInfo />,
      },
      {
        link: "verification-limit",
        component: <VerificataionLimit />,
      },
    ],
  },
  {
    link: "/processing-team",
    component: <ProcessingTeam />,
    protectedPath: true,
    children: [
      {
        link: "",
        component: <UserManagementCard />,
      },
      {
        link: "user-management",
        component: <UserManagement />,
      },
      {
        link: "new-card",
        component: <NewCard />,
      },
    ],
  },
  {
    link: "/admin",
    component: <Admin />,
    protectedPath: true,
    children: [
      {
        link: "",
        component: <Supplier />,
      },
      {
        link: "processing-management",
        component: <ProcessingManagement />,
      },
      {
        link: "card-request",
        component: <CardRequest />,
      },
      {
        link: "transaction-History",
        component: <TransactionHistory />,
      },
      {
        link: "rate-info",
        component: <AdminRateInfo />,
      },

      {
        link: "transaction-history/:id",
        component: <SupplierPaymentInfo />,
      },
      {
        link: "new-supplier",
        component: <NewSupplier />,
      },
      {
        link: "new-processing",
        component: <NewProcessing />,
      },
    ],
  },
  {
    link: "/",
    component: <Header />,
    protectedPath: false,
    children: [
      {
        link: "",
        component: <HomeScreen />,
      },
      {
        link: "fraud-prevention",
        component: <FraudPrevention />,
      },

      {
        link: "refund-policy",
        component: <RefundPolicy />,
      },

      {
        link: "termsOfSale",
        component: <TermsOfSale />,
      },
      {
        link: "termsofuse",
        component: <TermsOfUse />,
      },
      {
        link: "financialDisclosure",
        component: <FinancialDisclosure />,
      },
      {
        link: "afffiliateDisclosure",
        component: <AffiliateDisclosure />,
      },
      {
        link: "termsAndConditions",
        component: <TermsAndConditions />,
      },
      {
        link: "privacyPolicy",
        component: <PrivacyPolicy />,
      },
    ],
  },
  {
    link: "/signin",
    component: <Login />,
    protectedPath: false,
  },
  {
    link: "/signup",
    component: <Signup />,
    protectedPath: false,
  },
  {
    link: "/forgot-password",
    component: <ForgotPassword />,
    protectedPath: false,
  },
  {
    link: "/new-password",
    component: <NewPassword />,
    protectedPath: false,
  },
  {
    link: "/unauthorized",
    component: <Unauthorized />,
    protectedPath: false,
  },
  {
    link: "/profile",
    component: <Profile />,
  },
];

const AppRoute = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {routes.map(({ link, component, protectedPath, children }: IRoute) => (
          <Route
            key={Math.random()}
            path={link}
            element={
              <RequireAuth protectedPath={protectedPath}>
                {component}
              </RequireAuth>
            }
          >
            {children &&
              children?.length > 0 &&
              children.map(({ link, component }: IRoute) => (
                <Route key={Math.random()} path={link} element={component} />
              ))}
          </Route>
        ))}
        {/* <Route path="*" element={<Navigate to="/not-found" />} /> */}
      </Routes>
    </BrowserRouter>
  );
};
export default AppRoute;
